import { render } from "./VisitingReservation.vue?vue&type=template&id=ca21512e"
import script from "./VisitingReservation.vue?vue&type=script&lang=js"
export * from "./VisitingReservation.vue?vue&type=script&lang=js"

import exportComponent from "/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__